const errorMessages = {
	credentials: 'Wrong credentials. Please try again',
	serverErr: 'General server error. Please try again later',
	serverNoResponse: "Unable to reach server. Please try again later"
};

export default errorMessages;
